<hbox class="value">
  <!-- MainWindow on:click > Event url-tel > MeetBackground > VideoConfMeeting -->
  <a href="tel:{value}">
    {value}
  </a>
</hbox>

<script lang="ts">
  export let value: string;
</script>

<style>
</style>
